import React, { useEffect } from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';
import i18n from 'i18n';
import config from 'config';
import { useGeocoder } from 'hooks/GoogleMapsPlatform/useGeocoder';
import { useGoogleMapsUsage } from 'core/googleMapsUsage/useGoogleMapsUsage';
import { AbstractDynamicMovableOutdoorFormModel } from './DynamicMovableOutdoorFormModel';

const Inner: React.FC<{
  formModel: AbstractDynamicMovableOutdoorFormModel;
}> = ({ formModel }) => {
  const { recordGeocoding } = useGoogleMapsUsage(
    formModel.l1Object.channelGroupId
  );
  const [reverseGeocode] = useGeocoder(recordGeocoding);
  useEffect(() => {
    formModel.setReverseGeocode(reverseGeocode);
  }, [formModel, reverseGeocode]);
  return null;
};

/**
 * Hidden side-effect mount — wraps <APIProvider> around a binder that
 * pushes the resolved reverseGeocode fn onto the supplied form model.
 * Renders no visible UI. Designed to be plugged into
 * <EditLimitation renderGeocoderBinder={...} /> so it mounts whenever the
 * limitation editor is on screen — independent of whether the user has
 * clicked "Edit" on the inventory.
 *
 * No unmount cleanup on the binding — the reverseGeocode fn stays on the
 * form model after this component unmounts so submit (from the Summary
 * step, mounted after this component unmounts) still works.
 */
export const MovableOutdoorGeocoderBinder: React.FC<{
  formModel: AbstractDynamicMovableOutdoorFormModel;
}> = ({ formModel }) => (
  <APIProvider apiKey={config.googleMapsApiKey} language={i18n.language}>
    <Inner formModel={formModel} />
  </APIProvider>
);
